<template>
  <div class="app-root">
    <div class="app-root__wrap">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.app-root {
  display: flex;
  color: var(--ui-text-primary);
  background: var(--ui-color-white);
  direction: ltr;

  &__wrap {
    position: relative;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    max-width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    backface-visibility: hidden;
  }
}
</style>
